import React from "react";
import { useSelector } from "react-redux";
import { t } from "i18next";
import moment from "moment";

// import CustomModal from "components/CustomModal";
// import Close from "icons/Close";
import { useLang } from "hooks";
import { FormatPreOrderingTime } from "utils/OrderUtils";
import { getStoreAreaName } from "utils/storeUtils";
import C from "Constants";
import useOpenSavedAddressListModal from "service-hooks/useOpenSavedAddressListModal";
import SlideInLayout from "components/layouts/SlideInLayout";
import { TranslationText } from "components/TextTranslationContainer";
import {CustomButton as Button} from "components/Button";

export const ChangeSelectedLocationToModalContainerOption = ({
  onClick = () => {},
  title,
  subTitle,
  titleTag="h2",
  subTitleTag="h2"
}) => {
  return (
    <div
      className="flex justify-between items-center text-2xl font-bold p-2"
      onClick={onClick}
    >
      <div className="flex-1 flex flex-col text center">
        <TranslationText
          text={title}
          className="text-outer-space text-17x font-bold"
          as={titleTag}
        />
        <TranslationText
          text={subTitle}
          className="block cursor-pointer text-15x w-full font-semibold text-gray-400 capitalize"
          as={subTitleTag}
        />
      </div>
      <Button outline style={{
        width:"fit-content",
        padding:"0 10px"
      }}>
        <TranslationText text="Change" />
      </Button>
    </div>
  );
};

function ChangeDeliveringToModalContainer({
  isContainerModalopen,
  setContainerModalopen=()=>{},
  setPreOrderingSlotWidget=()=>{},
  setChngeAreaModalopen=()=>{},
  isPreORderEnabled,
  preORderSlots,
}) {
  const { currentLang } = useLang();

  const { orderTiming } = useSelector((state) => state?.orderTimingReducer);
  const { outletBasedSelectedStoreArea } = useSelector((state) => state?.store);
  const { shippingMethod } = useSelector((state) => state?.AppReducer);
  const { openAddressListModal } = useOpenSavedAddressListModal();

  return (
    <>
      <SlideInLayout
        open={isContainerModalopen}
        handleClose={() => setContainerModalopen(false)}
        container={{
          className: `p-2`,
          style: {
            height: "fit-content",
          },
        }}
      >
        <div id="discount-info-popup" className="flex flex-col gap-2 p-2 top-border-rounded">
          <ChangeSelectedLocationToModalContainerOption
            onClick={() => {
              openAddressListModal("fetch-all");
              setChngeAreaModalopen(true);
              // handleChangeOrderStore();             
              setContainerModalopen(false);
            }}
            title={"Delivering to"}
            subTitle={getStoreAreaName(
              currentLang,
              shippingMethod,
              outletBasedSelectedStoreArea
            )}
          />
          <ChangeSelectedLocationToModalContainerOption 
           onClick={() => {
            // if (isPreORderEnabled && preORderSlots?.length > 0) {
              setPreOrderingSlotWidget(true);
              setContainerModalopen(false);
            // }
          }}
          title={"Delivery Time"}
          subTitle={
            orderTiming?.TimingType === C.ORDER_TIMING_TYPE.PREORDER &&
                orderTiming?.preOrderSlot?.day &&
                orderTiming?.preOrderSlot?.time
                ? `${orderTiming?.preOrderSlot?.day === C.TODAY ? t(orderTiming?.preOrderSlot?.day) : moment(orderTiming?.preOrderSlot?.day).format("dddd, DD MMM YYYY")}, ${FormatPreOrderingTime(orderTiming?.preOrderSlot?.time)}`   
                : "ASAP"
          }
          subTitleTag="span"
          />      
        </div>
      </SlideInLayout>
    </>
  );
}

export default ChangeDeliveringToModalContainer;
